import React from 'react';

// Static curated previews per template. Keeps the upgrade dialog light and
// looking beautiful — real renders straight out of the studio.
const PREVIEWS = {
  star_ball: '/previews/star_ball.png',
  star_ball_plus: '/previews/star_ball.png',
  stripes_and_spots: '/previews/stripes_and_spots.png',
  stripes_and_spots_front: '/previews/stripes_and_spots_front.png',
};

export default function TemplatePreview({ templateId, size = 200 }) {
  const src = PREVIEWS[templateId];
  if (!src) return null;
  return (
    <div
      style={{ width: size, height: size }}
      className="rounded-2xl bg-slate-50 shadow-inner overflow-hidden mx-auto flex items-center justify-center"
      data-testid={`template-preview-${templateId}`}
    >
      <img
        src={src}
        alt="template preview"
        className="w-full h-full object-cover"
        loading="lazy"
      />
    </div>
  );
}
